module.exports = __webpack_public_path__ + "static/media/plusIcon.a9937c62.svg";